/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Privacy_LabelInputs */

const en_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzerklärung`)
};

const pt_br2_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidade`)
};

const tr_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası'nı kabul edersiniz`)
};

const zh_cn2_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const zh_hk2_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私隱政策`)
};

const ko_kr2_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 처리방침`)
};

const ru_ru2_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политикой конфиденциальности`)
};

const es_419_login_page_privacy_label = /** @type {(inputs: Login_Page_Privacy_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Login_Page_Privacy_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_privacy_label = /** @type {((inputs?: Login_Page_Privacy_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Privacy_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_privacy_label(inputs)
	if (locale === "de") return de_login_page_privacy_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_privacy_label(inputs)
	if (locale === "tr") return tr_login_page_privacy_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_privacy_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_privacy_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_privacy_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_privacy_label(inputs)
	return es_419_login_page_privacy_label(inputs)
});